import { reduxForm } from 'redux-form'
import differenceBy from 'lodash/differenceBy'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import at from 'lodash/at'

import { goBack } from 'react-router-redux'
import { fetchServicesForLocation } from '../../actions/services'
import { setServiceFilterForLocation } from '../../actions/work-tracker-filters'

import WorkTrackerServiceFilterModal from '../../components/work-trackers/work-tracker-service-filter-modal'

const fields = [
  'resourceId'
]

function mapStateToProps (state, ownProps) {
  const id = ownProps.params.locationId

  if (isEmpty(state.services)) {
    return {
      modalTitle: 'Choose a Service',
      hasNextPage: false,
      initialValues: {
        resourceId: get(state, `workTrackerFilters.${id}.serviceId`)
      },
    }
  }

  const resources = at(state.services, state.services.ids || [])
  const contractId = get(state, `workTrackerFilters[${id}].contractId`)
  const contractedServicesIds = get(state, `contracts[${contractId}.contractedServicesIds`, [])
  const contractedServices = at(state.services, contractedServicesIds || [])
  const otherServices = differenceBy(resources, contractedServices, 'id')

  return {
    modalTitle: 'Choose a Service',
    hasNextPage: false,
    initialValues: {
      resourceId: get(state, `workTrackerFilters.${id}.serviceId`)
    },
    contractedServices,
    otherServices
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.params.locationId

  dispatch(fetchServicesForLocation(id))

  return {
    handleClose () {
      dispatch(goBack())
    },

    onSubmit (data) {
      dispatch(setServiceFilterForLocation(id, data.resourceId))
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'workTrackerServicefilter'
  },
  mapStateToProps,
  mapDispatchToProps
)(WorkTrackerServiceFilterModal)



// WEBPACK FOOTER //
// ./src/containers/work-trackers/work-tracker-service-filter-container.js